import { Context } from 'components/hoc/Store';
import React, { useContext } from 'react';
import getLanguageObject from 'utils/getLanguageObject';

interface ITranslateText {
    children: string;
}

// Komponenta pouzita pro prekladani textu, sleduje v contextu language a podle jeji hodnoty vraci prislusny text
export const TranslateText: React.FC<ITranslateText> = ({ children }) => {
    const { language } = useContext(Context);

    return <>{getLanguageObject(language)[children] || children}</>;
};

export default TranslateText;
